/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";
import { NavLink } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { getContent } from "services/comoganhar.service";
import { RegulamentoFooter } from "components/regulamento-footer";

import { func } from "prop-types";

export function ComoGanhar() {
  const { user } = useAuth();
  const [content, setContent] = useState<any>();

  useEffect(() => {
    if (user) {
      // console.log(user.challenges);
      getContent().then(function (data) {
        setContent(data[0]);
      });
    }
  }, [user]);

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center space-y-0">
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div className="w-screen" id="comoGanhar">
            <div className="">
              {content && (
                <>
                  {/* <h2 dangerouslySetInnerHTML={{ __html: content.title }}></h2> */}
                  {/* {content.document && (
                    <p className="w-full text-right h-[40px] mb-5">
                      <a href={content.document.url} target="_blank">
                        VER REGULAMENTO
                      </a>
                    </p>
                  )} */}
                  <div
                    className="w-full"
                    dangerouslySetInnerHTML={{ __html: content.html }}
                  ></div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="bg-[#081c5a]">
          <RegulamentoFooter />
        </div>
      </div>
      <Outlet />
    </>
  );
}
